/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LegalFormEnum } from './LegalFormEnum';
import {
    LegalFormEnumFromJSON,
    LegalFormEnumFromJSONTyped,
    LegalFormEnumToJSON,
} from './LegalFormEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface InvestorList
 */
export interface InvestorList {
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    readonly activeOrdersSumGross: number;
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    readonly inactiveOrdersSumGross: number;
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    readonly openOrdersCount: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestorList
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvestorList
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    externalId?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestorList
     */
    readonly deleted: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvestorList
     */
    readonly deletedByCascade: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    titleBeforeName?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    titleAfterName?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    salutation?: string;
    /**
     * 
     * @type {Date}
     * @memberof InvestorList
     */
    birthDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    birthNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    companyId?: string;
    /**
     * 
     * @type {LegalFormEnum}
     * @memberof InvestorList
     */
    legalForm?: LegalFormEnum;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    representativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestorList
     */
    phone?: string;
    /**
     * Tax rate in %
     * @type {string}
     * @memberof InvestorList
     */
    taxRate?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InvestorList
     */
    validationResult?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof InvestorList
     */
    mainInvestor?: number;
}

/**
 * Check if a given object implements the InvestorList interface.
 */
export function instanceOfInvestorList(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('activeOrdersSumGross' in value)) return false;
    if (!('inactiveOrdersSumGross' in value)) return false;
    if (!('openOrdersCount' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('updatedAt' in value)) return false;
    if (!('deleted' in value)) return false;
    if (!('deletedByCascade' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function InvestorListFromJSON(json: any): InvestorList {
    return InvestorListFromJSONTyped(json, false);
}

export function InvestorListFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestorList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activeOrdersSumGross': json['active_orders_sum_gross'],
        'inactiveOrdersSumGross': json['inactive_orders_sum_gross'],
        'openOrdersCount': json['open_orders_count'],
        'createdAt': (dayjs(json['created_at']).toDate()),
        'updatedAt': (dayjs(json['updated_at']).toDate()),
        'externalId': json['external_id'] == null ? undefined : json['external_id'],
        'deleted': (json['deleted'] == null ? null : dayjs(json['deleted']).toDate()),
        'deletedByCascade': json['deleted_by_cascade'],
        'name': json['name'],
        'titleBeforeName': json['title_before_name'] == null ? undefined : json['title_before_name'],
        'titleAfterName': json['title_after_name'] == null ? undefined : json['title_after_name'],
        'salutation': json['salutation'] == null ? undefined : json['salutation'],
        'birthDate': json['birth_date'] == null ? undefined : (dayjs.tz(json['birth_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'birthNumber': json['birth_number'] == null ? undefined : json['birth_number'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'legalForm': json['legal_form'] == null ? undefined : LegalFormEnumFromJSON(json['legal_form']),
        'representativeName': json['representative_name'] == null ? undefined : json['representative_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'taxRate': json['tax_rate'] == null ? undefined : json['tax_rate'],
        'validationResult': json['validation_result'] == null ? undefined : json['validation_result'],
        'mainInvestor': json['main_investor'] == null ? undefined : json['main_investor'],
    };
}

export function InvestorListToJSON(value?: InvestorList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'external_id': value['externalId'],
        'name': value['name'],
        'title_before_name': value['titleBeforeName'],
        'title_after_name': value['titleAfterName'],
        'salutation': value['salutation'],
        'birth_date': value['birthDate'] == null ? undefined : (dayjs(value['birthDate'] as any).format('YYYY-MM-DD')),
        'birth_number': value['birthNumber'],
        'company_id': value['companyId'],
        'legal_form': LegalFormEnumToJSON(value['legalForm']),
        'representative_name': value['representativeName'],
        'email': value['email'],
        'phone': value['phone'],
        'tax_rate': value['taxRate'],
        'validation_result': value['validationResult'],
        'main_investor': value['mainInvestor'],
    };
}

